import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { successIconSx } from './Success.style';

export const Success = ({ sx }) => (
  <CheckCircleIcon fontSize="large" sx={{ ...successIconSx, ...sx }} />
);
